export enum ApprovalStatusCodes {
  pending = 0,
  approved = 1,
  rejected = -1
}
